module.exports = __webpack_public_path__ + "static/media/Menu-9.bb47ed06.jpg";